
        <!-- <div id="preloader"></div> -->
        <div  style="background-image:url('assets/img/background/body_bg_1.png');"> 

        <!-- Start breadcumb Area -->
        <div class="page-area">
            <div class="breadcumb-overlay"></div>
            <div class="container">
                <div class="row">
                    <div class="col-md-12 col-sm-12 col-xs-12">
                        <div class="breadcrumb text-center">
                            <div class="section-headline white-headline">
                                <h3>About us</h3>
                            </div>
                            <ul class="breadcrumb-bg">
                                <li class="home-bread">Home</li>
                                <li>About us</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End breadcumb Area -->
        <!-- about-area start -->
        <div class="about-area page-padding" style="padding-bottom: 50px;">
            <div class="container">
                <div class="row">
                    <div class="col-md-6 col-sm-12 col-xs-12">
                        <div class="about-image">
                            <img src="../../assets/img/about/ab.jpg" alt="">
                            <!-- <div class="video-content">
								<a href="https://www.youtube.com/watch?v=O33uuBh6nXA" class="video-play vid-zone">
									<i class="fa fa-play"></i>
								</a>
							</div> -->
                        </div>
                    </div>
                    <!-- column end -->
                    <div class="col-md-6 col-sm-12 col-xs-12">
                        <div class="about-content">
							<h3 style="color: aliceblue;">About DOKS</h3>
                            <p style="color: antiquewhite;">DOKS International started with a group of ambitious individuals who appreciate independent thinking and most importantly the value of integrity, honesty and friendship. 
                                We are a community of professional investors and traders that share the same ideology on how to invest and be profitable in highly competitive local and global markets and develop trading talent.
                                 DOKS International helps the investor achieve the realistic returns, identify potential areas, and guide you to be a successful investor and a trader. 
                                 Our business success relies on engaging a highly diverse team of people across the globe who are client-focused, think differently and draw on a range of backgrounds and experiences to contribute their unique perspective. 
                                Together we are relentlessly committed to making a difference and enriching lives!</p>
                            <!-- <div class="about-details">
                                <ul class="marker-list">
									<li>The phrasal sequence of the Lorem Ipsum text.</li>
									<li>ducimus adipisci voluptas consectetur adipisicing.</li>
									<li>consectetur adipisicing elit praesentium maxime.</li>
									<li>programmes can generate dummy text using..</li>
								</ul>
                            </div> -->
                        </div>
                    </div>
                    <!-- column end -->
                </div>
            </div>
        </div>
        <!-- about-area end -->
         <!-- about-area start -->
         <div class="about-area page-padding" style="padding-top: 10px;">
            <div class="container">
                <div class="row">
                    
                    <!-- column end -->
                    <div class="col-md-6 col-sm-12 col-xs-12">
                        <div class="about-content">
							<h3 style="color: aliceblue;">Our Mission</h3>
                            <p style="color: antiquewhite;">Our focus and ambition are to develop World Class Traders and Investors. 
                                We employ best people and invest in advanced and cutting-edge technologies to ensure that
                                 our students learn effectively and acquire the fundamental and technical skills for consistency in their trading. 
                                 DOKS group of professional trainers focus on trader skill development and understanding, 
                                 by using advanced proprietary technologies to boost trader’s ability to recall market patterns and to
                                  develop trading strategies that cater for a person’s unique personality and temperament. 
                                  This unique approach ensures our students are fully immersed into the most cutting edge and relevant training regarding strategies, 
                                approach and development techniques that keep our traders at the peak of their performance. 
                                With your dedication, we will make you a world class trader and an investor!</p>
                            <!-- <div class="about-details">
                                <ul class="marker-list">
									<li>The phrasal sequence of the Lorem Ipsum text.</li>
									<li>ducimus adipisci voluptas consectetur adipisicing.</li>
									<li>consectetur adipisicing elit praesentium maxime.</li>
									<li>programmes can generate dummy text using..</li>
								</ul>
                            </div> -->
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12 col-xs-12">
                        <div class="about-image">
                            <img src="../../assets/img/about/mission.jpg" alt="" style="height: 500x; width: 648px;">
                            <!-- <div class="video-content">
								<a href="https://www.youtube.com/watch?v=O33uuBh6nXA" class="video-play vid-zone">
									<i class="fa fa-play"></i>
								</a>
							</div> -->
                        </div>
                    </div>
                    <!-- column end -->
                </div>
            </div>
        </div>
        <!-- about-area end -->
        <!-- Start About Area -->
        <!-- <div class="about-feature-area bg-color area-padding-2">
            <div class="container">
                <div class="row">
                    <div class="about-mission">
                        <div class="col-md-4 col-sm-4 col-xs-12">
                            <div class="mission-about">
                                <div class="mission-icon">
                                    <i class="flaticon-004-bar-chart"></i>
                                </div>
                                <div class="mission-text">
                                    <h4>Our Mission</h4>
                                    <p>The phrasal sequence of the Lorem Ipsum text is now so widespread and commonplace that many DTP programme</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-4 col-xs-12">
                            <div class="mission-about">
                                <div class="mission-icon">
                                    <i class="flaticon-031-release"></i>
                                </div>
                                <div class="mission-text">
                                    <h4>Our Vision</h4>
                                    <p>The phrasal sequence of the Lorem Ipsum text is now so widespread and commonplace that many DTP programme</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-4 col-xs-12">
                            <div class="mission-about">
                                <div class="mission-icon">
                                    <i class="flaticon-023-management"></i>
                                </div>
                                <div class="mission-text">
                                    <h4>Our Experience</h4>
                                    <p>The phrasal sequence of the Lorem Ipsum text is now so widespread and commonplace that many DTP programme</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <!-- End About Area -->
        <!-- Start Banner Area -->
        <!-- <div class="banner-area area-padding">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 col-sm-12 col-xs-12">
                        <div class="banner-all area-80 text-center">
                            <div class="banner-content">
                                <h3>Our worldwide integration partner work with long time relationship </h3>
                                <a class="banner-btn" href="#">Onboard</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <!-- End Banner Area -->
        <!-- Start Feature Area -->
        <!-- <div class="feature-area bg-color fix area-padding">
            <div class="container">
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="feature-content">
                            <div class="feature-images">
                                <img src="../../assets/img/feature/f1.jpg" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="feature-text">
                            <h3>Your investment money more safe and secure</h3>
						    <p>Replacing a  maintains the amount of lines. When replacing a selection. help agencies to define their new business objectives and then create. Replacing a  maintains the amount of lines. When replacing a selection. help agencies to define their new business objectives and then create. Replacing a  maintains the amount of lines. When replacing a selection. help agencies to define their new business objectives and then create. </p>
                            
                            <a class="feature-btn" href="#">Get started now</a>
                        </div>
                    </div>
                </div>
                <div class="row margin-row">
                    <div class="col-md-6 col-sm-6 hidden-xs">
                        <div class="feature-text">
                            <h3>Risk free investment system of our policy</h3>
						    <p>Replacing a  maintains the amount of lines. When replacing a selection. help agencies to define their new business objectives and then create</p>
                            <ul>
                               <li><a href="#">Innovation idea latest business tecnology</a></li>
                                <li><a href="#">Digital content marketing online clients plateform</a></li>
                                <li><a href="#">Safe secure services for you online email account</a></li>
                            </ul>
                            <a class="feature-btn" href="#">Learn about more</a>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="overview-images">
                           <canvas id="bissChart" width="300" height="240"></canvas>
                        </div>
				    </div>
                    <div class="hidden-md hidden-lg hidden-sm col-xs-12">
                        <div class="feature-text">
                            <h3>Easily grow your business earn more money</h3>
						    <p>Replacing a  maintains the amount of lines. When replacing a selection. help agencies to define their new business objectives and then create</p>
                            <ul>
                               <li><a href="#">Innovation idea latest business tecnology</a></li>
                                <li><a href="#">Digital content marketing online clients plateform</a></li>
                                <li><a href="#">Safe secure services for you online email account</a></li>
                            </ul>
                            <a class="feature-btn" href="#">Learn more</a>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <!-- End Feature Area -->
       
		</div>